import {
    Route,
    Routes,
} from 'react-router-dom';
import {RequirePermission} from '../../utils/RequirePermission.tsx';

import {IndexPage} from './pages/IndexPage';
import {AddPage} from './pages/AddPage';
import {EditPage} from "./pages/EditPage.tsx";
import {rbacActions} from "../../config/rbac/actions.ts";

import {AddPage as AddOrganizationAccountPage} from '../organization-accounts/pages/AddPage';

export const OrganizationsLayout = () => {
    return (
        <Routes>
            <Route
                path='/'
                element={
                    <RequirePermission action='ListOrganizations' redirectTo='/'>
                        <IndexPage/>
                    </RequirePermission>
                }
            />
            <Route
                path='add'
                element={
                    <RequirePermission action='CreateOrganization' redirectTo='/organizations'>
                        <AddPage/>
                    </RequirePermission>
                }
            />
            <Route
                path=':id'
                element={
                    <RequirePermission action='GetOrganization' redirectTo='/organizations'>
                        <EditPage/>
                    </RequirePermission>
                }

            >
            </Route>

            <Route
                path=':id/organization-accounts/add'
                element={
                    <RequirePermission action={rbacActions.CreateOrganizationAccount} redirectTo='/organization-accounts'>
                        <AddOrganizationAccountPage/>
                    </RequirePermission>
                }
            />


        </Routes>
    );
};
